import React from "react";
import { DrawerMain } from "components";
import { SortButton } from "./sortButton";

export const SortDrawer = ({ ContentDrawer }) => {
  return (
    <div className="sort-drawer-wrapper">
      {ContentDrawer && (
        <DrawerMain
          anchor="bottom"
          OpeningComponent={(props) => <SortButton {...props} />}
          ContentDrawer={ContentDrawer}
        />
      )}
    </div>
  );
};
